import scope from "./scope";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "./selectors";
import SummaryType from "state/selections/Constants/SummaryType";
import { selectBaseGroupingParams } from "state/selections/selector";
import { exchange } from "@ls/js-fetch";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const REQUEST_TE_SBS_DATA = `${scope}/REQUEST_TE_SBS_DATA`;
export const RECEIVE_TE_SBS_DATA = `${scope}/RECEIVE_TE_SBS_DATA`;
export const requestTrackingErrorData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const absFactorsSet = new Set(),
      absCovarsSet = new Set(),
      relFactorsSet = new Set(),
      relCovarsSet = new Set();

    const teDefinitions = selectDefinitions(SelectionState.COMMITTED)(state);

    teDefinitions.forEach(({ factor, covarianceType, summary }) => {
      switch (summary) {
        case SummaryType.ABSOLUTE:
          absFactorsSet.add(factor);
          absCovarsSet.add(covarianceType);
          break;
        case SummaryType.RELATIVE:
          relFactorsSet.add(factor);
          relCovarsSet.add(covarianceType);
          break;
        default:
          throw new Error(`Unknown summary ${summary}`);
      }
    });

    if (absFactorsSet.size) {
      dispatch(
        makeTrackingErrorRequest(
          SummaryType.ABSOLUTE,
          [...absCovarsSet],
          [...absFactorsSet]
        )
      );
    }

    if (relFactorsSet.size) {
      dispatch(
        makeTrackingErrorRequest(
          SummaryType.RELATIVE,
          [...relCovarsSet],
          [...relFactorsSet]
        )
      );
    }
  };
};

const makeTrackingErrorRequest = (summary, covarMatrices, factors) => {
  return async (dispatch, getState) => {
    dispatch({ type: REQUEST_DATA, payload: { summary } });
    const state = getState();
    const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

    const [baseParams, sbsParams] = selectBaseGroupingParams(state);
    dispatch({
      type: RECEIVE_DATA,
      payload: {
        summary,
        data: (
          await exchange({
            params: {
              ...baseParams,
              summary,
              results: "TRACKING_ERRORS_GLOBAL",
              te_covars: covarMatrices.join(","),
              te_factors: factors.join(","),
            },
            url,
            cancelId: `te-data-${summary}`,
          })
        )?.data,
      },
    });
    if (sbsParams) {
      dispatch({ type: REQUEST_TE_SBS_DATA, payload: { summary } });
      dispatch({
        type: RECEIVE_TE_SBS_DATA,
        payload: {
          summary,
          data: (
            await exchange({
              params: {
                ...sbsParams,
                summary,
                results: "TRACKING_ERRORS_GLOBAL",
                te_covars: covarMatrices.join(","),
                te_factors: factors.join(","),
              },
              url,
              cancelId: `te-data-sbs-${summary}`,
            })
          )?.data,
        },
      });
    }
  };
};
